// extracted by mini-css-extract-plugin
var _1 = "webpack-containers-Review-Home-StageDetail-module__panelSection";
var _2 = "webpack-containers-Review-Home-StageDetail-module__progressPanel";
export { _1 as "panelSection", _2 as "progressPanel" }
